import { FormLabel } from "../form-label/FormLabel";
import { useEffect, useState } from "react";
import { collection, onSnapshot } from "@firebase/firestore";
import { db } from "../../services/firebase";
import { Rules } from "../../types";
import EnhancedRulesTable from "../table-rules/RulesDenseTable";

export default function ListaRegole({onSelect}: {onSelect: (rule: Rules) => void}) {
  const [listaRegole, setListRegole] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
    useEffect(() => {
        const colRef = collection(db, "rules");
        const unsubscribe = onSnapshot(
            colRef,
            (snap) => {
                const results: Rules[] = snap.docs.map((doc) => {
                    return { ...doc.data(), uid: doc.id };
                }) as Rules[];
                setListRegole(results);
                setLoading(false); // ✅ qui!
            },
            (error) => {
                console.error("Errore nella snapshot:", error);
                setLoading(false); // ✅ anche in caso di errore
            }
        );
        return () => unsubscribe();
    }, []);
  return (
    <div className={"container"}>
      <FormLabel label={"Lista Regole"} />
      <div>
        {loading ? <p>Caricamento...</p> : <EnhancedRulesTable onSelect={onSelect} data={listaRegole} />}
      </div>
    </div>
  );
}
